import React from "react";
// import { Button } from "../ui/button";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "../ui/table";

const AllCoupons = ({ coupons, setCoupons }) => {
  return (
    <main>
      <Table className="tw-border tw-rounded-lg tw-shadow-sm">
        <TableHeader className="tw-bg-[#00B5ED] tw-text-white">
          <TableRow>
            <TableHead className="tw-text-white tw-font-semibold tw-text-base">Name</TableHead>
            <TableHead className="tw-text-white tw-font-semibold tw-text-base">Code</TableHead>
            <TableHead className="tw-text-white tw-font-semibold tw-text-base">Discount</TableHead>
            <TableHead className="tw-text-white tw-font-semibold tw-text-base">Start Date</TableHead>
            <TableHead className="tw-text-white tw-font-semibold tw-text-base">End Date</TableHead>
            <TableHead className="tw-text-white tw-font-semibold tw-text-base">Expired</TableHead>
            {/* <TableHead>Actions</TableHead> */}
          </TableRow>
        </TableHeader>
        <TableBody>
          {coupons.length > 0 ? (
            coupons.map((coupon) => (
              <TableRow key={coupon._id} className="tw-border-b">
                <TableCell className="tw-p-4">{coupon.name}</TableCell>
                <TableCell className="tw-font-medium">
                  {coupon.couponCode}
                </TableCell>
                <TableCell>
                  {coupon.discountPercentage > 0
                    ? `${coupon.discountPercentage}%`
                    : `$${coupon.discountAmount}`}
                </TableCell>
                <TableCell>
                  {new Date(coupon.usageStartDate).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  {new Date(coupon.usageEndDate).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  <span
                    className={`tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full ${
                      coupon.isExpired
                        ? "tw-bg-red-500 tw-text-white"
                        : "tw-bg-green-500 tw-text-white"
                    }`}
                  >
                    {coupon.isExpired ? "Expired" : "Active"}
                  </span>
                </TableCell>
                {/* <TableCell>
                    <Button
                      variant="outline"
                      className="tw-text-[#00B5ED] tw-border-[#00B5ED] hover:tw-bg-[#00B5ED] hover:tw-text-white"
                    >
                      View
                    </Button>
                  </TableCell> */}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan="7" className="tw-text-center tw-py-4">
                No coupons found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </main>
  );
};

export default AllCoupons;
